import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, throwError, BehaviorSubject, from } from 'rxjs';
import { catchError, filter, take, switchMap } from 'rxjs/operators';

import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SessionService } from '../../core/services/session.service';
import Swal from 'sweetalert2';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  constructor(
    private session: SessionService,
    private router: Router,
    public snackBar: MatSnackBar
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return from(this.session.getToken()).pipe(
      switchMap((token) => {
        if (token != null) {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
            },
          });
        }
        request = request.clone({
          headers: request.headers.set('Accept', 'application/json'),
        });
        return next.handle(request).pipe(
          catchError((err) => {
            if (err.status === 401) {
              // Sesión inválida/expirada: limpiamos token y redirigimos al login
              Swal.fire({
                title: 'Sesión expirada',
                text: 'Tu sesión expiró. Por favor, iniciá sesión nuevamente.',
                icon: 'warning',
                confirmButtonColor: '#002968',
                confirmButtonText: 'Ir al Login',
              }).then(() => {
                this.session.removeToken().then(() => {
                  // Preservamos ruta actual para posible retorno
                  this.router.navigate(['/auth/login'], {
                    queryParams: { redirectTo: this.router.url },
                  });
                });
              });
            }
            if (err.status === 500 || err.status === 0) {
              Swal.fire({
                title: 'Error de conexión',
                text: 'Ocurrió un error al conectarse con el servidor',
                icon: 'error',
                confirmButtonColor: '#002968',
                confirmButtonText: 'Entendido',
              });
            }
            return throwError(err);
          })
        );
      })
    );
  }

  private addToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
  private handle401Error(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<any> {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return from(this.session.getToken()).pipe(
        switchMap((token: string) => {
          this.isRefreshing = false;
          this.refreshTokenSubject.next(token);
          return next.handle(this.addToken(request, token));
        })
      );
    } else {
      return this.refreshTokenSubject.pipe(
        filter((token) => token != null),
        take(1),
        switchMap((jwt) => {
          return next.handle(this.addToken(request, jwt));
        })
      );
    }
  }
}
